import { render, staticRenderFns } from "./instructions-for-using-vps.html.vue?vue&type=template&id=0d875430"
import script from "./instructions-for-using-vps.html.vue?vue&type=script&lang=js"
export * from "./instructions-for-using-vps.html.vue?vue&type=script&lang=js"
import style0 from "./instructions-for-using-vps.html.vue?vue&type=style&index=0&id=0d875430&prod&lang=scss"
import style1 from "./instructions-for-using-vps.html.vue?vue&type=style&index=1&id=0d875430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports